<template>
  <el-row class="permanence black-inputs">
    <el-col :span="12" :offset="6" class="permanence-container">
      <div class="permanence-title">Rechercher un restaurant</div>
      <el-select class="permanence-selector" v-loading="loadingRestos" value-key="id" @change="updateDropdowns"
        v-model="value" filterable placeholder="Select">
        <el-option v-for="item in getAUsersOrdered" :key="item.id" :label="item.name" :value="item">
        </el-option>
      </el-select>
      <div class="permanence-button">
        <el-button v-if="value !== ''" type="success" round @click="gotoResto()">Voir le Restaurant</el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Login',
  data: function () {
    return {
      userId: '',
      value: '',
      blop: null,
      loadingRestos: true,
      allUsers: null
    }
  },
  mounted: function () {
    this.findRealUserRole().then((u) => {
      if (!u || u === '' || u === 'User' || u === 'SubUser') {
        this.$router.replace('restaurant')
      } else {
        this.loadingRestos = true
        this.loadAUsers().then(res => {
          this.loadingRestos = false
          let sortTab = res
          sortTab.sort((a, b) => {
            if (a.name && b.name) {
              let uA = a.name.toLowerCase()
              let uB = b.name.toLowerCase()
              if (uA < uB) return -1
              if (uA > uB) return 1
            }
            return 0
          })
          // check if permanence is on
          let filtered = sortTab.filter(resto => {
            return resto.infos.permanenceOn
          })

          this.allUsers = filtered
        })
      }
    })
  },
  computed: {
    ...mapGetters({
      getUser: 'newUsers/getUser',
      getAUsers: 'newUsers/getAUsers'
    }),
    getAUsersOrdered: function () {
      if (this.allUsers) {
        let sortTab = this.allUsers
        sortTab.sort((a, b) => {
          let uA = a.name.toLowerCase()
          let uB = b.name.toLowerCase()
          if (uA < uB) return -1
          if (uA > uB) return 1
          return 0
        })
        // check if permanence is on
        let filtered = sortTab.filter(resto => {
          return resto.infos.permanenceOn
        })
        return filtered
      }
      return []
    }
  },
  methods: {
    ...mapActions({
      loadAUsers: 'newUsers/loadAUsers',
      resetAllStore: 'resetAllStore',
      findRealUserRole: 'newUsers/findRealUserRole'
    }),
    ...mapMutations({
      setUser: 'newUsers/setUser'
    }),
    updateDropdowns: function (val) {
      this.value = val
    },
    gotoResto: function () {
      this.$router.push({ name: 'PRedirect', params: { id: this.value.id } })
      window.location.reload()
    }
  }
}
</script>

<style lang="scss">
@use "../styles/components/layout/permanence";
@use "../styles/components/elements/blackInputs";
</style>
